// Altura reservada de cada slot do Montilla (anti-CLS), igual à dos banners que
// ele substituiu — medida em produção, em 1280, 820 e 375 px de viewport:
//
// • institucional (CampaignBanner do CMS antigo): 131px no desktop (altura fixa
//   do contêiner), 110px no mobile (arte de 328x110, que nunca aumentava);
// • Preparadão Enem (imagem fixa, 2048x243 / 720x240, `width: 100%`): 139px no
//   desktop de 1168px e 114px no mobile de 343px;
// • simulador (imagem fixa, 1168x138 / 328x75, `width: 100%`): 138px no desktop
//   e 78px no mobile.
//
// As imagens eram proporcionais à largura, e o contêiner ocupa ~91% da
// viewport até o teto de 1168px, então a altura sai em `vw` com teto em px.
// O mesmo valor está no preset do slot no Montilla (`packPresets.ZBannerCarousel`:
// `height` no mobile, `heightAt` a partir de 768px): caixa e criativo concordam.
// Valor de CSS (vai direto em `min-height`). Mobile é abaixo de 768px, o mesmo
// corte do SDK (`ads.mobileBreakpoint`) e das artes dos criativos.
export const MOBILE_BREAKPOINT = 768

const INSTITUTIONAL = { mobile: '110px', desktop: 'min(11vw, 131px)' }
// Banner dentro do conteúdo da lição: a coluna tem ~741px (e ~488px no tablet),
// não os 1168px da largura inteira, e a arte (1200x142) mantém a proporção de
// 8,45:1, então a altura acompanha a coluna: ~88px no desktop. Com a altura de
// largura inteira (131px) o `object-fit: cover` do pack cortava um terço de cada
// lado. No mobile a coluna ocupa a largura toda e vale a mesma altura.
const LESSON_CONTENT = { mobile: '110px', desktop: 'min(7vw, 88px)' }
const PREPARADAO = { mobile: '30.5vw', desktop: 'min(11vw, 139px)' }
const SIMULATOR = { mobile: '20.8vw', desktop: 'min(10.96vw, 138px)' }

export const MONTILLA_SLOT_HEIGHTS = {
  'enem-lesson-top': INSTITUTIONAL,
  'enem-lesson-middle': LESSON_CONTENT,
  'enem-page-bottom': INSTITUTIONAL,
  'enem-category-banner': PREPARADAO,
  'enem-home-banner': SIMULATOR,
}
